import { render, staticRenderFns } from "./Cars.vue?vue&type=template&id=0c4ec2b2&scoped=true&"
import script from "./Cars.vue?vue&type=script&lang=js&"
export * from "./Cars.vue?vue&type=script&lang=js&"
import style0 from "./Cars.vue?vue&type=style&index=0&id=0c4ec2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ec2b2",
  null
  
)

export default component.exports